import {type IAsset} from '@netx/core-asset-next/schema';
import {canViewAttributeHistoryForAsset} from './canViewAttributeHistoryForAsset';

export const canDownloadAttributeHistory = (asset?: IAsset): boolean =>
	canViewAttributeHistoryForAsset(asset);
